// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","documentContainer":"onfido-sdk-ui-Capture-documentContainer","faceContainer":"onfido-sdk-ui-Capture-faceContainer"};